import { useContext, useEffect, useRef, useState } from 'react'
import Brightness2Icon from '@material-ui/icons/Brightness2'
import WbSunnyRoundedIcon from '@material-ui/icons/WbSunnyRounded'
import MenuIcon from '@material-ui/icons/Menu'
import CloseIcon from '@material-ui/icons/Close'
import { ThemeContext } from '../../contexts/theme'
import { LanguageContext } from '../../contexts/language'
import './Navbar.css'

const Navbar = () => {
  const [{ themeName, toggleTheme }] = useContext(ThemeContext)
  const { userLanguage, setLanguage, portfolio, t } = useContext(LanguageContext)
  const { projects, skills, contact, experience } = portfolio
  const [showNavList, setShowNavList] = useState(false)
  const [showLanguageList, setShowLanguageList] = useState(false)
  const languageRef = useRef(null)

  const toggleNavList = () => setShowNavList(!showNavList)

  useEffect(() => {
    const closeLanguageList = (e) => {
      if (languageRef.current && !languageRef.current.contains(e.target)) {
        setShowLanguageList(false)
      }
    }
    const closeOnEscape = (e) => {
      if (e.key === 'Escape') setShowLanguageList(false)
    }

    document.addEventListener('mousedown', closeLanguageList)
    document.addEventListener('keydown', closeOnEscape)
    return () => {
      document.removeEventListener('mousedown', closeLanguageList)
      document.removeEventListener('keydown', closeOnEscape)
    }
  }, [])

  const selectLanguage = (language) => {
    setLanguage(language)
    setShowLanguageList(false)
  }

  return (
    <nav className='center nav'>
      <ul
        style={{ display: showNavList ? 'flex' : null }}
        className='nav__list'
      >
        {projects.length ? (
          <li className='nav__list-item'>
            <a
              href='#projects'
              onClick={toggleNavList}
              className='link link--nav'
            >
              {t.projects}
            </a>
          </li>
        ) : null}

        {experience.length ? (
          <li className='nav__list-item'>
            <a
              href='#work-experience'
              onClick={toggleNavList}
              className='link link--nav'
            >
              {t.experience}
            </a>
          </li>
        ) : null}

        {skills.length ? (
          <li className='nav__list-item'>
            <a
              href='#skills'
              onClick={toggleNavList}
              className='link link--nav'
            >
              {t.skills}
            </a>
          </li>
        ) : null}

        {contact ? (
          <li className='nav__list-item'>
            <a
              href='#contact'
              onClick={toggleNavList}
              className='link link--nav'
            >
              {t.contact}
            </a>
          </li>
        ) : null}
      </ul>

      <div ref={languageRef} className='nav__language'>
        <button
          type='button'
          onClick={() => setShowLanguageList(!showLanguageList)}
          className='btn btn--icon nav__language-btn'
          aria-haspopup='listbox'
          aria-expanded={showLanguageList}
          aria-label='select language'
        >
          {userLanguage}
          <span
            className={
              showLanguageList
                ? 'nav__language-arrow nav__language-arrow--open'
                : 'nav__language-arrow'
            }
          >
            ▾
          </span>
        </button>

        {showLanguageList ? (
          <ul className='nav__language-list' role='listbox' aria-label='languages'>
            {['en', 'it', 'es'].map((language) => (
              <li key={language} role='option' aria-selected={language === userLanguage}>
                <button
                  type='button'
                  onClick={() => selectLanguage(language)}
                  className={
                    language === userLanguage
                      ? 'nav__language-option nav__language-option--active'
                      : 'nav__language-option'
                  }
                >
                  {language}
                </button>
              </li>
            ))}
          </ul>
        ) : null}
      </div>

      <button
        type='button'
        onClick={toggleTheme}
        className='btn btn--icon nav__theme'
        aria-label='toggle theme'
      >
        {themeName === 'dark' ? <WbSunnyRoundedIcon /> : <Brightness2Icon />}
      </button>

      <button
        type='button'
        onClick={toggleNavList}
        className='btn btn--icon nav__hamburger'
        aria-label='toggle navigation'
      >
        {showNavList ? <CloseIcon /> : <MenuIcon />}
      </button>
    </nav>
  )
}

export default Navbar
